import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { CustomButton } from "../../../../../components/customButton/CustomButton";
import { CustomInput } from "../../../../../components/customInput/CustomInput";
import {
  BlackClear,
  EditBeneficiary_Svg,
} from "../../../../../resources/assetsManager";
import { BLACK_COLOR, BG_COLOR } from "../../../../../resources/colorsManager";
import { beneficiaryDropdown } from "../../../../../resources/dropdownData";
const RowContainer = ({ value, title }) => {
  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      <p
        style={{
          fontSize: 14,
          color: BLACK_COLOR,
          padding: 0,
          margin: 0,
          marginRight: 20,
        }}
      >
        {title}
      </p>
      <p
        style={{
          fontSize: 14,
          color: BLACK_COLOR,
          padding: 0,
          margin: 0,
        }}
      >
        {value}
      </p>
    </div>
  );
};
function SendMoneyBeneficiary({
  name,
  accountNumber,
  ifsc,
  onClickSubmit,
  onClose,
  loading = false,
  onClickEdit,
  isEditRequired = true,
  balance,
}) {
  const [amount, setAmount] = useState("");
  const [transferType, setTransferType] = useState("");
  const [disabled, setDisabled] = useState(true);
  const { enqueueSnackbar } = useSnackbar();
  const inputStyle = {
    backgroundColor: BG_COLOR,
    alignSelf: "center",
    marginBottom: 15,
    height: 50,
    width: "100%",
    boxShadow: "none",
    // minWidth: 280,
    // maxWidth: 400,
  };

  const pStyle = {
    padding: 0,
    margin: 0,
    fontSize: 13,
    color: BG_COLOR,
    color: "#c0c0c0",
  };
  const pTitle = {
    fontSize: 14,
    color: BLACK_COLOR,
    padding: 0,
    margin: 0,
    marginRight: 20,
  };

  const pValue = {
    fontSize: 14,
    color: BLACK_COLOR,
    padding: 0,
    margin: 0,
  };

  useEffect(() => {
    if (amount !== "" && transferType !== "") {
      setDisabled(false);
    } else setDisabled(true);
  }, [amount, transferType]);
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
      }}
    >
      <div
        style={{
          width: "100%",
          height: "100%",
          backgroundColor: BG_COLOR,
          maxHeight: 160,
          marginBottom: 20,
        }}
      >
        <p
          style={{
            ...pStyle,
            padding: "5px 10px",
          }}
        >
          Beneficiary Details:
        </p>

        <div
          style={{
            width: "100%",
            padding: "0px 0px 10px 20px",
          }}
        >
          {/* <RowContainer title={"Name :"} value={name} />
          <RowContainer title={"Account Number :"} value={accountNumber} />
          <RowContainer title={"IFSC code :"} value={ifsc} /> */}
          <div
            style={{
              display: "flex",
              width: "100%",
            }}
          >
            <div
              style={{
                width: "50%",
                display: "flex",
                flexDirection: "column",
                marginLeft: 20,
              }}
            >
              <p style={pTitle}>Name:</p>
              <p style={pTitle}>Account Number:</p>
              <p style={pTitle}>IFSC Code:</p>
            </div>
            <div
              style={{
                width: "50%",
              }}
            >
              <p style={pTitle}>{name}</p>
              <p style={pTitle}>{accountNumber}</p>
              <p style={pTitle}>{ifsc}</p>
            </div>
          </div>
          {isEditRequired && (
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "flex-end",
                padding: 10,
              }}
            >
              <img
                src={EditBeneficiary_Svg}
                style={{
                  cursor: "pointer",
                }}
                onClick={onClickEdit}
              />
            </div>
          )}
        </div>
      </div>
      <p
        style={{
          ...pStyle,
        }}
      >
        Enter the Amount
      </p>
      <CustomInput
        value={amount}
        onChange={(val) => {
          setAmount(val);
        }}
        type="input"
        validator="amount"
        inputStyles={{
          ...inputStyle,
          marginBottom: 0,
        }}
        placeholder=""
      />

      <p
        style={{
          ...pStyle,
          color: "red",
          marginBottom: 20,
        }}
      >
        Amount cannot be in paise*
      </p>
      <p
        style={{
          ...pStyle,
        }}
      >
        Type
      </p>

      <CustomInput
        value={transferType}
        onChange={(val) => {
          setTransferType(val);
        }}
        type="select"
        placeholder=""
        options={beneficiaryDropdown}
        inputStyles={{
          backgroundColor: BG_COLOR,
          height: 50,
          width: "100%",
          borderRadius: 5,
          padding: 0,
          margin: 0,
          maxWidth: "100%",
          minWidth: 100,
        }}
        dropdownStyle={{
          width: "100%",
          padding: 0,
          margin: 0,
        }}
      />

      <CustomButton
        title="Submit"
        styles={{
          width: "100%",
          marginTop: 40,
          border: "none",
          height: 45,
          borderRadius: 4,
          marginBottom: 20,
        }}
        disabled={disabled}
        onClick={() => {
          // setStep(1);
          if (Number(balance) <= 0 || Number(amount) < 10) {
            if (Number(amount) < 10) {
              enqueueSnackbar("Minimum amount should be 10", {
                variant: "error",
              });
            } else
              enqueueSnackbar("Insufficient balance", {
                variant: "error",
              });
          } else {
            onClickSubmit({
              transferType,
              amount,
            });
          }
        }}
        loading={loading}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    balance: state.BalanceReducer.clientBalance,
  };
};

export default connect(mapStateToProps)(SendMoneyBeneficiary);
